import { Controller } from "@hotwired/stimulus";

// Replaces the falco-webkit <booking-timer> Vue component -- the last real
// Vue mount in the app (see git history for the removed vue_component()
// helper and vue_helper.js pack that mounted it).
//
// Same behaviour as the Vue original: the provisional-reservation hold
// counts down once a second, and when it reaches zero a blocking dialog
// appears whose only action sends the user back to a fresh search. The
// starting value is server-rendered (see _booking_timer.html.erb), so this
// only has to keep ticking -- there's no initial paint to do, and no
// flash of an empty timer before JS boots.
export default class extends Controller {
  static targets = ["display", "overlay"];
  static values = { seconds: Number, redirectUrl: String };

  connect() {
    this.remaining = this.secondsValue;
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  tick() {
    this.remaining = Math.max(this.remaining - 1, 0);
    this.render();

    if (this.remaining === 0) {
      clearInterval(this.interval);
      this.expire();
    }
  }

  render() {
    if (!this.hasDisplayTarget) return;

    const minutes = Math.floor(this.remaining / 60);
    const seconds = this.remaining % 60;
    const pad = (value) => String(value).padStart(2, "0");

    this.displayTarget.textContent = `${pad(minutes)}:${pad(seconds)}`;
  }

  // The Vue original only opened its modal when a redirect URL was given
  // (no URL meant the timer just ran out silently) -- keep that, otherwise
  // the dialog's only action would be a dead end.
  expire() {
    if (!this.hasOverlayTarget || !this.redirectUrlValue) return;

    this.overlayTarget.classList.remove("hidden");
    this.overlayTarget.classList.add("flex");
  }

  close() {
    if (this.redirectUrlValue) window.location.href = this.redirectUrlValue;
  }
}
